<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户编号')">
              <a-input :placeholder="$t('请输入用户编号')" v-model="queryParam.meterUserId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表编号')">
              <a-input :placeholder="$t('请输入表编号')" v-model="queryParam.meterId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('账户实时表变动前金额')">
              <a-input :placeholder="$t('请输入账户实时表变动前金额 单位分')" v-model="queryParam.userPreAccountNum"></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('账户变动后剩余金额')">
                <a-input :placeholder="$t('请输入账户变动后剩余金额 单位分')" v-model="queryParam.userNowAccountNum"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户账户变动前用户累积量')">
                <a-input :placeholder="$t('请输入用户账户变动前用户累积量')" v-model="queryParam.userPreWaterNum"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户变动后用水累计量')">
                <a-input :placeholder="$t('请输入用户变动后用水累计量')" v-model="queryParam.userNowWaterNum"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户账户变动金额')">
                <a-input :placeholder="$t('请输入用户账户变动金额')" v-model="queryParam.userChangeAccountNum"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户金额变动类型')">
                <a-input :placeholder="$t('请输入用户金额变动类型 1开户 2充值 3计费 4补水 5退水 6换表')" v-model="queryParam.userAccountChangeType"></a-input>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
        </span>

      </a-table>
    </div>

    <meter-user-account-change-record-modal ref="modalForm" @ok="modalFormOk"></meter-user-account-change-record-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import MeterUserAccountChangeRecordModal from './modules/MeterUserAccountChangeRecordModal'

  export default {
    name: 'MeterUserAccountChangeRecordList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      MeterUserAccountChangeRecordModal
    },
    data () {
      return {
        description: 'meter_user_account_change_record管理页面',
        url: {
          list: "/jeecg-charge/meter/meterUserAccountChangeRecord/list",
          delete: "/jeecg-charge/meter/meterUserAccountChangeRecord/delete",
          deleteBatch: "/jeecg-charge/meter/meterUserAccountChangeRecord/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterUserAccountChangeRecord/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterUserAccountChangeRecord/importExcel",
          
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:(t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'meterUserId'
          },
          {
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId'
          },
          {
            title: this.$t('账户实时表变动前金额'),
            align:"center",
            dataIndex: 'userPreAccountNum'
          },
          {
            title: this.$t('账户变动后剩余金额'),
            align:"center",
            dataIndex: 'userNowAccountNum'
          },
          {
            title: this.$t('账户变动金额'),
            align:"center",
            dataIndex: 'userChangeAccountNum'
          },
          {
            title: this.$t('金额变动类型'),
            align:"center",
            dataIndex: 'userAccountChangeType'
          },
          {
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title: this.$t('创建操作员代码'),
            align:"center",
            dataIndex: 'createBy'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:80,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      initDictConfig(){
      }
    }
  }
</script>
<style scoped>
</style>